// module cache are used so entry inlining is disabled
// startup
// Load entry module and return exports
__webpack_require__("../../../node_modules/webpack-dev-server/client/index.js?protocol=ws%3A&hostname=0.0.0.0&port=3003&pathname=%2Fws&logging=info&reconnect=10");
__webpack_require__("../../../node_modules/webpack/hot/dev-server.js");
var __webpack_exports__ = __webpack_require__("./index.js");
